
import React, { Component } from 'react';
import { PlusOutlined, RightOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import PubSub from 'pubsub-js'
import SensorSet from "./sensorSet/sensorSet"
import EmergencySet from "./emergencySet/emergencySet"
import EmergencyLighting from "./emergencyLighting/emergencyLighting"
import './controlPage.less';
import light_normal3 from "../../../imgs/mesh/light_normal3.png";
import { SET_ControlPageDetailPage_DIALOG_HIDE } from "../../../const/infoConst"


import { meshLog, SPRemove, SPGet, SPSet } from "../../../utils/spUtils";


export default class ControlPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedGroup: null,
            activeTab: "Sensor Control",
            powerOn: true,
            dimLevel: 50,
            cct: 3500,
            motion: false,
            daylight: false,
            vacant: false,
            controlPageDetailPage: false,
            groups: [
                { id: 1, name: "Office 01" }
            ]
        };
    };

    componentDidMount() {
        PubSub.subscribe(SET_ControlPageDetailPage_DIALOG_HIDE, (msg, index) => {
            //状态更新
            const controlPageDetailPage = this.state.controlPageDetailPage
            this.setState({ controlPageDetailPage: !controlPageDetailPage });
        })
    }


    sendDataToParent() {
        this.props.onDataToParent("");
        this.setState({ controlPageDetailPage: false });
    };

    handleTabChange = (tab) => {
        this.setState({ activeTab: tab });
        this.setState({ controlPageDetailPage: false });
        PubSub.publish('updateGroupdataUI', '')//刷新组的数据
    };




    render() {
        const { groups, selectedGroup, activeTab } = this.state;
        return (
            <div className="control-container">
                <div className="ui_grey_bg" />
                <div className="popup">
                    <h3 style={{ marginLeft: "20px" }}>Group Management</h3>
                    {/* Tabs */}
                    <div className="tabs">
                        <button
                            className={activeTab === "Sensor Control" ? "active" : ""}
                            onClick={() => this.handleTabChange("Sensor Control")}
                        >
                            Sensor Control
                        </button>
                        <button
                            className={activeTab === "Emergency Driver" ? "active" : ""}
                            onClick={() => this.handleTabChange("Emergency Driver")}
                        >
                            Emergency Driver
                        </button>
                        <button
                            className={activeTab === "Emergency Lighting" ? "active" : ""}
                            onClick={() => this.handleTabChange("Emergency Lighting")}
                        >
                            Emergency Lighting
                        </button>
                    </div>

                    {/* 动态内容 */}
                    {(activeTab === "Sensor Control") ? <div><SensorSet /></div> : (activeTab === "Emergency Driver") ? <div><EmergencySet /></div> : <div><EmergencyLighting /></div>}

                    {/* 底部按钮 */}
                    <div className="control-footer">
                        <button className='cancelBtn' onClick={this.sendDataToParent.bind(this)}>Cancel</button>

                        <button className='okBtn' onClick={this.sendDataToParent.bind(this)}>Confirm</button>
                    </div>
                </div>
            </div>


        );
    }
}
